import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {PopoverInfo} from 'shells/popover-info/popover-info';
import {Body} from 'shells/typography/body';

import type {MeetingFragment as Meeting} from 'nutshell-graphql-types';

import {getHostsForMeeting} from './helpers';
import {MeetingHostCard} from './meeting-host-card';

type Props = {
    meeting: Meeting;
    refetchMeeting: () => any;
};

export function MeetingHostsSection(props: Props) {
    const meetingHosts = getHostsForMeeting(props.meeting);

    // @ts-expect-error
    const needsAttentionHosts = [];
    // @ts-expect-error
    const validHosts = [];
    // gets a list of issues for each host and splits them into two arrays: one for hosts with no issues and one for hosts with issues
    meetingHosts.forEach((host) => {
        const userIssues = props.meeting.validity.issues.filter(
            (issue) => issue.user.id === host.id
        );
        if (userIssues.length === 0) {
            validHosts.push(host);
        } else {
            needsAttentionHosts.push({host, userIssues});
        }
    });

    return props.meeting.meetingType === 'ROUND_ROBIN' && props.meeting.hosts.length === 0 ? (
        <Body isItalic={true}>This meeting cannot be booked because this team has no members</Body>
    ) : (
        <StackLegacy spacing={8}>
            {/* @ts-expect-error */}
            {validHosts.map((host) => {
                return (
                    <MeetingHostCard
                        key={host.id}
                        hostId={host.id}
                        meeting={props.meeting}
                        name={host.name}
                        firstName={host.firstName}
                        timezone={host.timezone}
                        refetchMeeting={props.refetchMeeting}
                    />
                );
            })}
            {needsAttentionHosts.length > 0 && (
                <StackLegacy spacing={8}>
                    <div className='flex'>
                        <Body>Needs attention</Body>
                        {/* Check the copy on this, not sure if it's listed anywhere in spec/figma */}
                        <PopoverInfo
                            size={16}
                            info='The following user(s) will need to connect one or more external tools before they can be included as meeting hosts.'
                        />
                    </div>
                    {/* @ts-expect-error */}
                    {needsAttentionHosts.map(({host, userIssues}) => {
                        return (
                            <MeetingHostCard
                                key={host.id}
                                hostId={host.id}
                                meeting={props.meeting}
                                name={host.name}
                                firstName={host.firstName}
                                timezone={host.timezone}
                                issues={userIssues}
                                refetchMeeting={props.refetchMeeting}
                            />
                        );
                    })}
                </StackLegacy>
            )}
        </StackLegacy>
    );
}
